export enum PhraseDetailsTabItemTooltipType {
  APP, TELEGRAM, FAVORITE
}
export const PhraseDetailsTabItemTooltips: Record<PhraseDetailsTabItemTooltipType, string> = {
  [PhraseDetailsTabItemTooltipType.APP]: 'Switch on this button to appear in the application',
  [PhraseDetailsTabItemTooltipType.TELEGRAM]: 'Switch on this button to appear in a telegram bot',
  [PhraseDetailsTabItemTooltipType.FAVORITE]: 'Switch on this button to pin in the prompts menu',
}
